import React, { useEffect, useRef, useState } from "react";
import { ToastTypes } from "../contexts/toastr.context";
import { UserService } from "../_service/user.service";
import { Button } from "./button.component";

import BulkUserSample from "./../_assets/sample_files/bulk_import_sample.csv";
import { TextInput } from "./text-input.component";
import Table from "./table.component";
import { ActionModal } from "./action-modal.component";
import Switch from "./switch.component";
import { Loader } from "./loader.component";
import galleryIcon from "../_assets/images/gallery.png";
import uploadIcon from "../_assets/images/upload.png";
import { OrganizationService } from "../_service/organization.service";
import { TrackService } from "../_service/track.service";
import trashIcon from "../_assets/images/trash.png";
import { history } from "../_config";
import imageCompression from "browser-image-compression";

let fileUploaded = null;
let mp3Uploaded = null;

const TrackManagement = ({
  user,
  addToast,
  showAddTrack = false,
  setShowAddTrack,
  showEditTrack = false,
  setShowEditTrack,
  setTrackList,
  trackList,
  trackData = {},
}) => {
  const categories = [
    { value: "patientGratification", label: "Patient Gratification" },
    { value: "copingwithGrief", label: "Coping With Grief" },
    { value: "workRelationships", label: "Work Relationships" },
    { value: "workLifeBalance", label: "Work-Life Balance" },
    { value: "breakingRoutine", label: "Breaking Routine" },
    { value: "slowingDown", label: "Slowing Down" },
    { value: "rediscoveringPurpose", label: "Rediscovering Purpose" },
    { value: "dailyFrustration", label: "Daily Frustrations" },
  ];

  const hiddenFileInput = useRef(null);
  const hiddenFileMp3 = useRef(null);

  const [trackImg, setTrackImg] = useState(null);
  const [trackImageName, setTrackImageName] = useState("");

  const [trackMp3, setTrackMp3] = useState(null);
  const [trackMp3Name, setTrackMp3Name] = useState("");

  const [trackName, setTrackName] = useState("");
  const [category, setCategory] = useState("workLifeBalance");
  const [speaker, setSpeaker] = useState("");
  const [description, setDescription] = useState("");

  const [trackImgURL, setTrackImgURL] = useState(null);
  const [trackMp3URL, setTrackMp3URL] = useState(null);

  const [isOrgActive, setIsOrgActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isTrackActive, setIsTrackActive] = useState(false);

  useEffect(() => {
    if (showEditTrack) {
      setCategory(trackData.category);
      setTrackName(trackData.title);
      setSpeaker(trackData.speaker);
      setDescription(trackData.description);

      setTrackImg(trackData.imageURL);
      setTrackImageName(trackData.imageURL);

      setTrackMp3(trackData.mp3URL);
      setTrackMp3Name(trackData.mp3URL);

      setIsTrackActive(trackData.isActive ? trackData.isActive : false);
    }
  }, []);

  const isTrackFormSubmitable =
    trackName.trim().length >= 1 &&
    trackMp3 != null &&
    category != null &&
    trackImg != null &&
    trackImageName.length >= 1 &&
    speaker.trim().length >= 1 &&
    trackName.trim().length >= 1 &&
    description.trim().length >= 1;

  const handleChange = (event) => {
    fileUploaded = event.target.files[0];
    setTrackImageName(fileUploaded.name);
    setTrackImg(URL.createObjectURL(fileUploaded));
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChangeMp3 = (event) => {
    mp3Uploaded = event.target.files[0];
    setTrackMp3Name(mp3Uploaded.name);
    setTrackMp3(mp3Uploaded);
  };

  const handleClickMp3 = (event) => {
    hiddenFileMp3.current.click();
  };

  const uploadImgOrTrack = (data) => {
    return new Promise((resolve, reject) => {
      TrackService.uploadAudio(user, data)
        .then((resp) => {
          resolve(resp);
        })
        .catch((error) => {
          reject(JSON.parse(JSON.stringify(error)));
        });
    });
  };

  const addTrackHandler = async (event) => {
    setIsLoading(true);
    let imgUploadURL = null;
    if (showEditTrack) {
      imgUploadURL = trackData.imageURL;
    }
    if (trackImg) {
      if (fileUploaded) {
        const formData = new FormData();

        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(fileUploaded, options);
        compressedFile.lastModifiedDate = new Date();

        formData.append("file", compressedFile, compressedFile.name);
        await uploadImgOrTrack(formData)
          .then(async (img) => {
            imgUploadURL = img.url;
            await setTrackImgURL(img.url);
          })
          .catch((error) => {
            console.log(error);
            fileUploaded = null;
            setIsLoading(false);
            if (error && error?.message) {
              addToast(error.message, "", ToastTypes.danger);
            }
            if (error && error.response && error.response.data.message) {
              addToast(error.response.data.message, "", ToastTypes.danger);
            }
          });
      }
    }

    if (trackMp3) {
      if ((mp3Uploaded && showAddTrack) || (mp3Uploaded && showEditTrack)) {
        const formData1 = new FormData();
        formData1.append("file", mp3Uploaded, mp3Uploaded.name);
        uploadImgOrTrack(formData1)
          .then(async (mp3Data) => {
            await setTrackMp3URL(mp3Data.url);
            mp3Uploaded = null;
            fileUploaded = null;
            if (showAddTrack) {
              await addTrackData(imgUploadURL, mp3Data.url, mp3Data.duration);
            } else {
              await editTrackData(imgUploadURL, mp3Data.url, mp3Data.duration);
            }
          })
          .catch((error) => {
            setIsLoading(false);
            mp3Uploaded = null;
            fileUploaded = null;
            if (error && error?.message) {
              addToast(error.message, "", ToastTypes.danger);
            }
            if (error && error?.response && error?.response?.data?.message) {
              addToast(error?.response?.data?.message, "", ToastTypes.danger);
            }
          });
      } else {
        mp3Uploaded = null;
        fileUploaded = null;
        await editTrackData(imgUploadURL, trackData.mp3URL, trackData.duration);
      }
    }
  };

  const addTrackData = async (imgLink, mp3Link, duration) => {
    const trackObj = {
      imageURL: imgLink,
      mp3URL: mp3Link,
      title: trackName,
      description: description.trim(),
      speaker: speaker,
      category: category,
      duration,
    };

    await TrackService.addTrack(user, trackObj)
      .then((resp) => {
        setIsLoading(false);
        let trackData = trackList;
        trackData.unshift({
          ...resp,
          isPlaying: false,
          audio: new Audio(resp.mp3URL),
        });
        setTrackList(trackData);
        setShowAddTrack(false);
        setShowEditTrack(false);
        addToast("Track added successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
      });
  };

  const handleDelete = (event) => {
    setTrackImg(null);
    setTrackImageName("");
    fileUploaded = null;
  };

  const editTrackData = (imgLink, mp3Link, duration) => {
    const trackObj = {
      imageURL: imgLink,
      mp3URL: mp3Link,
      title: trackName,
      description: description.trim(),
      speaker: speaker,
      category: category,
      isActive: isTrackActive,
      duration,
    };
    TrackService.updateTrack(user, trackData._id, trackObj)
      .then((resp) => {
        let globalTrackList = trackList;
        let index = globalTrackList.findIndex((tr) => tr._id === trackData._id);
        if (index !== -1) {
          setIsLoading(false);
          globalTrackList[index] = {
            ...resp,
            isPlaying: false,
            audio: new Audio(resp.mp3URL),
          };
          setTrackList(globalTrackList);
          addToast("Track edited successfully", "", ToastTypes.success);
          setShowAddTrack(false);
          setShowEditTrack(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error && error.response && error.response.data.message) {
          addToast(error.response.data.message, "", ToastTypes.danger);
        }
        console.log(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl w-full px-6 py-9 add-edit-track-container"
      style={{ minHeight: "80vh" }}>
      {/* <div>
					<div className="flex justify-between px-5">
						<p className="font-bold text-lg text-primary">Edit Track</p>
					</div>
        </div> */}
      <div>
        <div className="flex justify-between px-5">
          <p className="font-bold text-lg text-primary">
            {showAddTrack ? "Add New Track" : "Edit Track"}
          </p>
        </div>
        <div className="mx-8 my-6 mb-0">
          {showEditTrack &&
          !showAddTrack &&
          Object.keys(trackData).length <= 0 ? (
            <Loader />
          ) : null}
          <div className="flex track-info-container mt-8 w-5/6 m-auto pb-6 border-b">
            <div className="image-pick-container">
              <div
                className="show-img border flex items-center rounded-md"
                style={{ backgroundColor: !trackImg ? "#F4FAFF" : "" }}>
                {trackImg ? (
                  <img
                    src={trackImg}
                    alt=""
                    className="h-full w-full object-contain rounded-md"
                  />
                ) : (
                  <div className="w-full">
                    <img
                      src={galleryIcon}
                      alt=""
                      className="h-10 object-contain w-full text-center flex"
                    />
                    <div className="text-xs text-center w-9/12 m-auto mt-2 t-grey">
                      Upload an image of the Track.
                    </div>
                  </div>
                )}
              </div>
              <div className="text-xxs mt-2 pb-2 t-grey">
                (Upload file below 20MB)
              </div>
              <div className="flex w-full items-center">
                <input
                  type="file"
                  className="hidden"
                  id="my-file"
                  ref={hiddenFileInput}
                  onChange={handleChange}
                  accept="image/gif, image/jpeg, image/png"
                />
                <div className="border py-1 flex items-center rounded-md overflow-hidden cursor-pointer justify-center w-full">
                  <img
                    src={uploadIcon}
                    alt=""
                    className="h-5 w-5 rounded-md"
                    onClick={handleClick}
                  />
                  <div
                    className={`flex pl-1 t-grey ${
                      trackImageName ? "mr-2 pr-2 border-r" : ""
                    } `}
                    onClick={handleClick}>
                    Choose a file
                  </div>
                  {trackImageName ? (
                    <div className="z-10 w-20 overflow-x-scroll whitespace-nowrap mostly-customized-scrollbar t-grey">
                      {trackImageName}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {trackImg ? (
                  <div
                    className="ml-2 rounded cursor-pointer"
                    onClick={() => handleDelete()}>
                    <img
                      src={trashIcon}
                      alt=""
                      className="h-5 w-5 rounded-md"
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="ml-20 detail-container w-full">
              <div className="m-auto w-3/4">
                <div>
                  <p htmlFor="orgname" className="text-base t-grey">
                    Title of the Track*
                  </p>
                  <TextInput
                    key="1"
                    defaultValue={trackName}
                    value={trackName}
                    type="text"
                    validator={(value) => {
                      if (value.trim().length <= 0) {
                        return "Enter valid Track title";
                      }
                    }}
                    containerClassName="flex-grow block"
                    className="py-2 items-center t-grey"
                    onChange={(value) => {
                      setTrackName(value);
                    }}
                  />
                </div>
                <div className="my-5">
                  <p htmlFor="orgname" className="text-base t-grey">
                    Add Track*
                  </p>
                  {/* <TextInput
												key="1"
												defaultValue={speaker}
												value={speaker}
												type="text"
												validator={(value) => {
													if (value.length <= 0) {
														return "Enter valid Speaker";
													}
												}}
												containerClassName="flex-grow block"
												className="py-2 items-center t-grey"
												onChange={(value) => {
													setSpeaker(value);
												}}
											/> */}
                  <input
                    type="file"
                    className="hidden"
                    id="my-file"
                    ref={hiddenFileMp3}
                    onChange={handleChangeMp3}
                    accept=".mp3, audio/*"
                  />
                  <div className="border py-1 flex items-center rounded-md overflow-hidden cursor-pointer justify-between my-3 px-3">
                    <div className="flex">
                      <img
                        src={uploadIcon}
                        alt=""
                        className="h-5 w-5 rounded-md"
                        onClick={handleClickMp3}
                      />
                      <div
                        className={`flex pl-2 t-grey ${
                          trackMp3Name ? "mr-2 pr-2 border-r" : ""
                        } `}
                        onClick={handleClickMp3}>
                        Choose a file
                      </div>
                    </div>
                    {trackMp3Name ? (
                      <div className="z-10 w-28 overflow-x-auto whitespace-nowrap mostly-customized-scrollbar t-grey">
                        {trackMp3Name}
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="my-5">
                  <p htmlFor="country" className="text-base t-grey">
                    Category*
                  </p>
                  <div className="">
                    <select
                      className="border theme-bg-default theme-border-default rounded flex items-center my-3 py-1 px-2 t-grey w-full"
                      value={category}
                      onChange={(e) => {
                        setCategory(e.target.value);
                      }}>
                      {categories.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className="my-5">
                  <p htmlFor="orgname" className="text-base t-grey">
                    Speaker*
                  </p>
                  <TextInput
                    key="1"
                    defaultValue={speaker}
                    value={speaker}
                    type="text"
                    validator={(value) => {
                      if (value.trim().length <= 0) {
                        return "Enter valid Speaker";
                      }
                    }}
                    containerClassName="flex-grow block"
                    className="py-2 items-center t-grey"
                    onChange={(value) => {
                      setSpeaker(value);
                    }}
                  />
                </div>
                <div className="my-2">
                  <p htmlFor="subscription" className="text-base t-grey">
                    Description*
                  </p>
                  <div className="block w-full">
                    <textarea
                      type="text"
                      rows={6}
                      maxLength="750"
                      value={description}
                      placeholder="Enter Description"
                      className="p-2 t-grey border mb-2 items-center w-full mt-2 rounded"
                      onChange={(e) => {
                        setDescription(e.target.value);
                      }}
                    />
                    {/* <div className="text-red-500">
													{trackName && speaker && category && description.length <= 0
														? "Enter description"
														: ""}
												</div> */}
                  </div>
                </div>
                {showEditTrack ? (
                  <div className="flex py-4 items-center justify-between">
                    <p className="w-1/2 t-grey font-bold">Account Status</p>
                    <div className="w-full">
                      <div className="t-grey font-normal w-full text-center flex justify-center">
                        {isTrackActive ? (
                          <div className="text-green-500">Active</div>
                        ) : (
                          <div className="text-red-500">Inactive</div>
                        )}
                        <Switch
                          className="ml-2"
                          toggle={isTrackActive}
                          setToggle={setIsTrackActive}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div
            className={`flex pt-8 w-5/6 ${
              isLoading ? "justify-center" : "justify-end"
            }`}>
            <Button
              label={showAddTrack ? "Add Track" : "Edit Track"}
              className="btn-primary px-8"
              onClick={addTrackHandler}
              disabled={!isTrackFormSubmitable}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackManagement;
